export const ALERT_TYPE_LABELS: Record<string, string> = {
    SOS: 'SOS',
    CheckOnMe: 'Check On Me',
    FakeCall: 'Fake Call',
    RiskReview: 'Visit Risk Review',
    Shift: 'Shift',
    Appointment: 'Appointment',
};

export const getAlertTypeLabel = (alertType?: string | null): string =>
    (alertType && ALERT_TYPE_LABELS[alertType]) || alertType || '----';
